{
  "kk": {
    "cashbackBottomSheet": {
      "value": "{value} ₸ бастап",
      "exact": "{value} ₸",
      "title": "Билет ақысынан үстеме кешбэк алыңыз!",
      "subTitle": "Біз билет ақысын кешбэгін ескере отырып жазамыз. Соның арқасында қанша ақша үнемдейтініңізді бірден көресіз.",
      "howWorks": {
        "title": "Бұл қалай болмақ?",
        "first": "Сіз билеттің бар ақысын төлейсіз.",
        "second": "Банк кешбэгіңізді картаңызға аударады.",
        "third": "Сөйтіп сіз билетіңзді төмен бағаға алған боласыз."
      },
      "withCashback": "кешбэкті шегерсек",
      "confirm": "Түсінікті"
    }
  },
  "ru": {
    "cashbackBottomSheet": {
      "value": "от {value} ₸",
      "exact": "{value} ₸",
      "title": "Оплачивайте билеты с повышенным кешбэком!",
      "subTitle": "Мы показываем цены с учетом кешбэка, чтобы вы сразу видели свою выгоду.",
      "howWorks": {
        "title": "Как это работает?",
        "first": "Вы оплачиваете полную стоимость.",
        "second": "Банк возвращает кешбэк на вашу карту.",
        "third": "Вы получаете обещанную низкую цену."
      },
      "withCashback": "с кешбэком",
      "confirm": "Понятно"
    }
  },
  "en": {
    "cashbackBottomSheet": {
      "value": "from {value} ₸",
      "exact": "{value} ₸",
      "title": "Get extra cashback from ticket price!",
      "subTitle": "We show prices with cashback, so you can see your savings right away.",
      "howWorks": {
        "title": "How does it work?",
        "first": "You pay the full price of the ticket.",
        "second": "The bank transfers your cashback to your card.",
        "third": "So you get the promised low price."
      },
      "withCashback": "with cashback",
      "confirm": "OK"
    }
  }
}
